module.exports = __webpack_public_path__ + "va.ba8283aa59227ca84324.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/va.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/va.svg
// module chunks = styles